import { FormattedMessage } from 'react-intl';

import Heading from '@atlaskit/heading';
import { Flex, Stack } from '@atlaskit/primitives-next';

import { messages } from './messages';

export const BaseRelationshipsSection = ({ children }: { children: React.ReactNode }) => {
	return (
		<Stack space="space.100">
			<Heading size="small" as="h2">
				<FormattedMessage {...messages.relationshipsSectionBaseTitle} />
			</Heading>
			<Flex gap="space.200" justifyContent="space-evenly">
				{children}
			</Flex>
		</Stack>
	);
};
